module.exports = __webpack_public_path__ + "media/sub4-5-3.3f64b495.mp4";